import { defineStore, } from 'pinia'
import fetch from '@/assets/js/src/util/fetch'
import { getDefaultHeaders, } from '@/assets/js/src/util/fetch/defaultHeaders'
import { checkResponse, commitMessage, handleException, } from '@/assets/js/src/util/apiTools'

const API_REGISTER_NEWSLETTER = '/api/crm-newsletter'

export const useNewsletterActionsStore = defineStore('newsletterActions', {
    actions: {
        async register ({ data, }) {
            try {
                // Api-Request senden
                let apiResponse = await fetch({
                    url: API_REGISTER_NEWSLETTER,
                    options: {
                        method: 'POST',
                        body: JSON.stringify(data),
                        headers: getDefaultHeaders({}),
                    },
                })

                // Api-Response prüfen
                if (checkResponse(apiResponse)) {
                    throw new Error('Fehler in Api-Response')
                }

                // Zeige Erfolgsmeldung
                commitMessage(apiResponse)

                return true
            } catch (e) {
                // Evtl. Fehler ausgeben
                handleException(e, false, true)
            }
        },
    },
})
